/**
 * File lined-media.js
 * 
 * Linked Media block: Slick.js slideshow on viewports below 768px.
 * Slides and autoplay behavior for videos can be extended here.
 *
 * @package wildrivers
 */

import 'slick-slider';

const LINKED_MEDIA_BREAKPOINT = 768;
const MEDIA_QUERY = window.matchMedia(`(max-width: ${LINKED_MEDIA_BREAKPOINT - 1}px)`);

function get$() {
	return typeof window.jQuery !== 'undefined' ? window.jQuery : null;
}

function initSlick(container) {
	const $ = get$();
	if (!$ || !container || $(container).hasClass('slick-initialized')) return;
	$(container).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: false,
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
	});
	$(container).on('afterChange', () => pauseVideosInContainer(container));
}

function destroySlick(container) {
	const $ = get$();
	if (!$ || !container || !$(container).hasClass('slick-initialized')) return;
	$(container).slick('unslick');
}

function setupLinkedMediaSliders() {
	const $ = get$();
	if (!$) return;

	const slideContainers = document.querySelectorAll('.linked-media--items');
	slideContainers.forEach((slider) => {
		if (MEDIA_QUERY.matches) {
			initSlick(slider);
		} else {
			destroySlick(slider);
		}
	});
}

/**
 * Send a command to a Vimeo iframe via postMessage.
 * @param {HTMLIFrameElement} iframe
 * @param {string} method - e.g. 'play', 'pause'
 */
function vimeoPostMessage(iframe, method) {
	if (!iframe?.contentWindow) return;
	iframe.contentWindow.postMessage(JSON.stringify({ method }), '*');
}

/** Pause all Vimeo videos inside a container (e.g. a Slick slider). */
function pauseVideosInContainer(container) {
	if (!container) return;
	container.querySelectorAll('.linked-media--vimeo-video').forEach((iframe) => {
		vimeoPostMessage(iframe, 'pause');
		const videoPlaying = container.querySelector('.linked-media--item.is-playing');
		videoPlaying?.classList.remove('is-playing');
	});
}

function handlePlayVideo() {
	const linkedVideos = document.querySelectorAll('.linked-media--video');
	linkedVideos?.forEach((videoEl) => {
		const iframe = videoEl.querySelector('.linked-media--vimeo-video');
		const item   = videoEl.closest('.linked-media--item');
		const cover  = item?.querySelector('.wp-block-cover__background');
		if (!iframe || !item) return;

		// 1) Play on hover, pause on leave — unless user clicked the cover (is-playing)
		videoEl.addEventListener('mouseenter', () => {
			vimeoPostMessage(iframe, 'play');
		});
		videoEl.addEventListener('mouseleave', () => {
			if (!item.classList.contains('is-playing')) {
				vimeoPostMessage(iframe, 'pause');
			}
		});

		// 2) Click on video: hide cover and ::before overlay
		videoEl.addEventListener('click', (e) => {
			e.preventDefault();
			if ( item.classList.contains('is-playing') ) {
				item.classList.remove('is-playing');
				return;
			}
			item.classList.add('is-playing');
		});

		// 3) Click on cover: keep playing when mouse leaves (hide overlay, start video)
		cover?.addEventListener('click', (e) => {
			e.preventDefault();
			if ( item.classList.contains('is-playing') ) {
				item.classList.remove('is-playing');
				vimeoPostMessage(iframe, 'pause');
				return;
			}
			item.classList.add('is-playing');
			vimeoPostMessage(iframe, 'play');
		});
	});
}

export function linkedMedia() {
	const $ = get$();
	if (!$) return;

	setupLinkedMediaSliders();

	MEDIA_QUERY.addEventListener('change', () => {
		setupLinkedMediaSliders();
	});

    handlePlayVideo();
}
